class QuantityButtons {

  constructor(element) {
    this.elementMinus = element.querySelector('.quantity__button--minus');
    this.elementPlus = element.querySelector('.quantity__button--plus');
    this.elementQuantity = element.querySelector('.qty');
    this.events = 'click';

    this.currentVal = parseFloat(this.elementQuantity.getAttribute('value'));
    this.max = parseFloat(this.elementQuantity.getAttribute('max'));
    this.min = parseFloat(this.elementQuantity.getAttribute('min'));
    this.step = this.elementQuantity.getAttribute('step');

    this.init();
    this.formatValues();
    this.eventListeners();

  }

  eventListeners() {
    this.elementMinus.addEventListener(this.events, this.decrease.bind(this));
    this.elementPlus.addEventListener(this.events, this.increase.bind(this));
  }

  formatValues() {
    if (!this.currentVal || this.currentVal === '' || this.currentVal === 'NaN') this.currentVal = 0;
    if (this.max === '' || this.max === 'NaN') this.max = '';
    if (this.min === '' || this.min === 'NaN') this.min = 0;
    if (this.step === 'any' || this.step === '' || this.step === undefined || parseFloat(this.step) === 'NaN') this.step = 1;
  }

  decrease() {
    if (this.min && (this.currentVal <= this.min)) {
      this.elementQuantity.value = this.min;
    } else if (this.currentVal > 0) {
      this.elementQuantity.value = this.currentVal = parseFloat((this.currentVal - parseFloat(this.step)).toFixed(this.step.getDecimals()));
    }
    this.elementQuantity.dispatchEvent(new Event('input', { bubbles: true }))
  }

  increase() {
    if (this.max && (this.currentVal >= this.max)) {
      this.elementQuantity.value = this.max;
    } else {
      this.elementQuantity.value = this.currentVal = parseFloat((this.currentVal + parseFloat(this.step)).toFixed(this.step.getDecimals()));
    }
    this.elementQuantity.dispatchEvent(new Event('input', { bubbles: true }))
  }

  init() {
    if (!String.prototype.getDecimals) {
      String.prototype.getDecimals = function () {
        const num = this,
          match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
        if (!match) {
          return 0;
        }
        return Math.max(0, (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0));
      }
    }
  }
}

class QuantityButtonsInit {
  constructor(elementClass = '.js-quantity') {
    this.containerClass = elementClass;

    this.init();
  }

  init() {
    this.elementCartForm = document.querySelector('.woocommerce-cart-form');
    this.containers = document.querySelectorAll(this.containerClass);
    this.processing = false;
    this.containers.forEach(container => {
      new QuantityButtons(container);
    });

    if(this.elementCartForm) {
      this.mutationObserver = new MutationObserver(this.contentChanged.bind(this))
      this.eventListeners();
    }
  }

  eventListeners() {
    this.mutationObserver.observe(
      this.elementCartForm,
      { attributes: true }
    )
  }

  contentChanged(mutationsList, observer){
    mutationsList.forEach(mutation => {
      if (mutation.attributeName === 'class') {
        if(mutation.target.classList.contains('processing') && !this.processing){
          this.processing = true;
        } else if(!mutation.target.classList.contains('processing') && this.processing) {
          this.init();
        }
      }
    })
  }
}

export default QuantityButtonsInit;
